import { Dispatch, SetStateAction, useEffect, useState } from "react";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";

import LeftDrawerContent from "./LeftDrawerContent";
import { useCompensateForScrollbarVisibilityToPreventPageRerender } from "../drawerUtils";

type LeftDrawerProps = {
  open: boolean;
  onOpen: () => void;
  onClose: () => void;
  setIsLeftDrawerOpen: Dispatch<SetStateAction<boolean>>;
  isFiltersDrawer?: boolean | null;
};

const LeftDrawer = ({
  open,
  onOpen,
  onClose,
  setIsLeftDrawerOpen,
}: LeftDrawerProps) => {
  useCompensateForScrollbarVisibilityToPreventPageRerender(open);
  const [contentHidden, setContentHidden] = useState(true);
  useEffect(() => {
    if (open) {
      setContentHidden(false);
    }
  }, [open]);
  return (
    <SwipeableDrawer
      // BackdropProps={{ invisible: true }}
      anchor="left"
      disableDiscovery={true}
      disableSwipeToOpen={true}
      open={open}
      onClose={onClose}
      onOpen={onOpen}
      disableScrollLock={true}
      onAnimationEnd={() => {
        if (!open) {
          setContentHidden(true);
        }
      }}
    >
      {/* height: 100% to make the blue background style the full height of the drawer -- this is for the LeftDrawerContent */}
      <div tabIndex={0} role="button" style={{ height: "100%" }}>
        {contentHidden ? null : (
          <LeftDrawerContent setIsLeftDrawerOpen={setIsLeftDrawerOpen} />
        )}
      </div>
    </SwipeableDrawer>
  );
};

export default LeftDrawer;
